module.exports = __webpack_public_path__ + "static/media/ic_profile.615b8a20.svg";